<!--
 * @Author: DY
 * @Date: 2022-10-09 10:22:30
 * @LastEditTime: 2023-01-16 20:37:45
 * @Description:
 * @FilePath: \ConcreteCloud.Mobile\src\views\public\aboutUs.vue
-->
<template>
    <div class="aboutUs">
        <section>
            <div class="logo">
                <img src="@/assets/images/my/logo.png" alt="">
                <p>当前版本：{{ currentVersion }}</p>
            </div>
            <van-divider>◇</van-divider>
            <div class="describe">
                <p>砼享云-专为商混企业提供智能管理系统解决方案，具备智能、共享、整合三大特性：</p>
                <p>智能：使混凝土企业的采购、生产、调度、过磅、物流、质量、合同、质量、统计等业务流程更加便捷高效。</p>
                <p>共享：让商混企业的办公更加碎片化，让整个行业上下游企业服务更加敏捷。 整合：即将OA系统、ERP系统、工控系统、监控系统等有机的对接整合，也从PC端到移动端，全方位、立体化的整合，为商混企业提供一体化服务，将集团业务管理深度融合。</p>
                <p>砼享云是基于移动互联网、物联网、大数据、人工智能等先进技术，构建便捷，安全可靠。 砼享云由集团端子系统、客户端子系统、司机端子系统、业务端子系统、供应端子系统等5部分组成。专业的服务满足商混企业的信息化、智能化、移动化、平台化、集团化的运营管理需求。</p>
            </div>
            <div class="agreement_box">
                <div class="btn_box">
                    <span @click="openClickFun('/agreement')">用户协议</span>
                    <span class="shu">|</span>
                    <span @click="openClickFun('/privacy')">隐私政策</span>
                </div>
                <div class="beian_box">
                    <span @click="openClickFun('/agreement')">APP备案号：</span>
                    <a href="https://beian.miit.gov.cn/">京ICP备19023620号-10A</a>
                </div>
                <div class="versions_box">
                    Copyright @ 2024 北京霁云科技有限公司. All Rights Reserved
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    // 关于我们
    name: 'about-us',
    components: {},
    props: {},
    data() {
        return {
            currentVersion: '1.0.2', // 当前版本号
        };
    },
    computed: {},
    watch: {},
    created() {
        this.$callMobile('JYTeamsNative', 'jyGetAppVersion');
        // 转发原生回调函数
        window.callback_SendAppVersion = this.callback_SendAppVersion;
    },
    mounted() {},
    destroyed() {},
    methods: {
        callback_SendAppVersion(data) {
            if (data) {
                const versionData = JSON.parse(data);
                this.currentVersion = versionData.version;
            }
        },
        openClickFun(path) {
            this.$router.isBack = 2;
            this.$router.push({ path: path });
        },
    },
};
</script>
<style lang="stylus" scoped>
.aboutUs
    height 100%
    position relative
    section
        height 100%
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
        .logo
            height 165rpx
            padding-top 25rpx
            text-align center
            img
                width 90rpx
                height 90rpx
            p
                font-size 12rpx
                color #979EA7
                margin-top 10rpx
        .van-divider
            margin 0
            color #F0F0F0
        .describe
            padding 5rpx 14rpx 0
            p
                font-size 14rpx
                line-height 24rpx
                color #333333
                text-indent 2rem
        .agreement_box
            width 100%
            position absolute
            left 0
            bottom 20rpx
            .btn_box
                display flex
                justify-content center
                align-items center
                span
                    color #1b69b6
                    text-decoration underline
                    &.shu
                        padding 0 8rpx
            .beian_box
                display flex
                justify-content center
                align-items center
                color #979ea7
                font-size 12rpx
                margin-top 2rpx
            .versions_box
                display flex
                justify-content center
                align-items center
                color #979ea7
                font-size 12rpx
                margin-top 2rpx
</style>